export default () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.27 2.31686C11.4519 2.12187 11.7116 2 12.0004 2C12.2564 2 12.5124 2.0975 12.7083 2.29344L17.7076 7.29198C18.0986 7.6829 18.0986 8.31569 17.7076 8.70661C17.3176 9.0966 16.6847 9.0966 16.2937 8.70661L12.9998 5.41321V14.998C12.9998 15.5502 12.5526 15.9983 12.0003 15.9983C11.4481 15.9983 10.9999 15.5502 10.9999 14.998V5.41513L7.70791 8.70661C7.31787 9.0966 6.68405 9.0966 6.29401 8.70661C5.90303 8.31569 5.90303 7.6829 6.29401 7.29198L11.27 2.31686ZM3.00038 14.0006C3.55264 14.0006 4.00082 14.4487 4.00082 15.0009V19.0001C4.00082 19.2654 4.10583 19.5195 4.29336 19.707C4.48089 19.8944 4.73496 19.9995 5.00031 19.9995H18.9996C19.265 19.9995 19.52 19.8945 19.7066 19.707C19.8941 19.5195 20.0001 19.2654 20.0001 19.0001V15.0009C20.0001 14.4487 20.4473 14.0006 20.9996 14.0006C21.5528 14.0006 22 14.4487 22 15.0009V19.0001C22 19.796 21.684 20.5582 21.1215 21.1216C20.5589 21.6841 19.7957 22 18.9997 22H5.00034C4.20431 22 3.44203 21.6841 2.87948 21.1216C2.31597 20.5582 2 19.796 2 19.0001V15.0009C2 14.4487 2.44813 14.0006 3.00038 14.0006Z"
      fill="currentColor"
    />
  </svg>
);
